export default {"src":"/_next/static/media/list.badce6a6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};